/**
 * 홈 이벤트 배너 링크를 앱(RN 웹뷰)에서 어떻게 열지 정한다.
 *
 * 이벤트 배너는 원래 외부 이벤트 사이트용이라 앱에서는 무조건 `OPEN_APP`(외부로 열기)을 보냈다.
 * 어드민에서 포탈 게시글 링크를 등록하면 그대로 외부로 나가 버리는데, iOS 는 앱이 직접 연
 * 유니버설 링크를 그 앱으로 되돌려주지 않아 Safari 로 가고, Android 는 App Link 로 앱에
 * 되돌아오는 바람에 플랫폼마다 결과가 갈렸다. 링크 종류를 보고 포탈 링크는 앱 안에서 연다.
 *
 * - board    : 포탈 게시글(`/board/<id>`) → 홈이 이미 쓰는 게시글 모달 (메인 배너·피드와 동일)
 * - portal   : 그 밖의 포탈 페이지 → 앱 모달(`MODAL`) 로 띄운다
 * - external : 포탈 밖 → 지금처럼 `OPEN_APP`
 */
export type EventBannerLinkTarget =
  | { readonly kind: 'board'; readonly documentId: string }
  | { readonly kind: 'portal'; readonly url: string }
  | { readonly kind: 'external'; readonly url: string };

const BOARD_PATH = /^\/board\/([^/?#]+)/;

/**
 * @param link   어드민에 등록한 링크. 상대 경로(`/board/...`)도 받는다.
 * @param origin 지금 떠 있는 포탈의 origin (`window.location.origin`). 같은 origin 이면 포탈 링크로 본다.
 */
export const resolveEventBannerLink = (
  link: string,
  origin: string,
): EventBannerLinkTarget => {
  let url: URL;
  try {
    url = new URL(link, origin);
  } catch {
    return { kind: 'external', url: link };
  }

  if (url.origin !== origin) {
    return { kind: 'external', url: link };
  }

  const board = url.pathname.match(BOARD_PATH);
  if (board) {
    return { kind: 'board', documentId: decodeURIComponent(board[1]) };
  }
  return { kind: 'portal', url: url.href };
};
